import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { NewsList } from './NewsList'
import { NewsProps } from './types'

export const News: FC<NewsProps> = ({ seo, header, footer, content: { breadcrumb, title, subtitle, news } }) => (
  <Page seo={seo} header={header} footer={footer}>
    <Featured breadcrumb={breadcrumb} title={title} subtitle={subtitle} />
    <NewsList news={news} />
  </Page>
)
